import { ThemeUICSSObject } from '@apia/theme';
import formsAssistant from './formsAssistant';
/* IMPORT HERE */

const execution: ThemeUICSSObject = {
  formsAssistant,
  /* PREPEND HERE */
};

export default execution;
